import(/* webpackMode: "eager" */ "/opt/customer-accounts/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/customer-accounts/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/customer-accounts/src/app/preferences/components/Contact/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/customer-accounts/src/app/preferences/components/Delivery/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/customer-accounts/src/app/preferences/components/Notifications/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/customer-accounts/src/app/preferences/components/Returns/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/customer-accounts/src/components/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/customer-accounts/src/lib/mui.ts");
